// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'iview'
import App from './App'
import {router} from './router/index'
import Antd, { FormModel,Icon } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'iview/dist/styles/iview.css'
import axios from './libs/axios2'
import * as echarts from 'echarts';
import 'echarts-liquidfill'
// import $ from 'jquery'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Antd)
Vue.use(FormModel)
Vue.use(Icon)
Vue.use(iView)
Vue.use(ElementUI)

Vue.prototype.$myHttp = axios
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
function queryStringToObj () {
  const str = location.href

  const regExp = /(?:\?|&)([^&]*)/g
  let result = ''
  const obj = {}

  while ((result = regExp.exec(str)) !== null) {
      const kv = result[1].split('=')
      obj[kv[0]] = kv[1]
  }

  return obj
}
// localStorage.setItem('tenantCode', queryStringToObj().tenantCode || 'ivy')
localStorage.setItem('tenantCode', queryStringToObj().tenantCode || 'zaxl')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js